import { useId } from 'react';

import { Campo } from '@/componentes/Campo';

/**
 * O CÓDIGO DA MÁQUINA, que ninguém digita (0131, decisão 57).
 *
 * Pedido do dono (29/10/2026): o código é do sistema, criado pelo tipo e pela
 * sequência ("a sétima escavadeira é ESC-007"). Fica MOSTRADO, e não
 * escondido: é por ele que a máquina é chamada na obra, e quem cadastra quer
 * ver o que vai nascer. Campo de leitura com o rótulo de sempre, para a grade
 * do formulário não mudar de forma.
 */
export function CampoDoCodigo({ valor, ajuda }: { readonly valor: string; readonly ajuda: string }) {
  const id = useId();
  return (
    <Campo id={id} rotulo="Código" ajuda={ajuda}>
      <input
        id={id}
        type="text"
        readOnly
        value={valor}
        className="controle w-full bg-rebaixada tabular-nums text-tinta-secundaria"
      />
    </Campo>
  );
}
